import React, { Fragment } from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Box, useMediaQuery, Typography } from "@mui/material";

import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import FundingCard from "./FundingCard";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  firstChild: {
    height: { xs: "800px", md: "800px", lg: "800px", xl: "974px" },
    backgroundImage: "linear-gradient(to bottom, #081b3e 0%, #26233f 100%)",
    width: { xs: "100%" },
    borderRadius: "0 0 50px 50px",
    mt: { xs: "108.5px" },
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  title: {
    color: theme.palette.red.main,
    fontSize: { xs: "14px", md: "16px" },
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontFamily: theme.typography.montserrat.semibold,
  },
  subtitle: {
    color: theme.palette.white.main,
    fontSize: { xs: "32px", md: "43px", lg: "54px", xl: "65px" },
    lineHeight: { xs: "41.3px", md: "45px", lg: "54px", xl: "65px" },
    fontFamily: theme.typography.montserrat.light,
    textAlign: { xs: "center" },
    maxWidth: { xs: "100%", md: "700px", lg: "900px", xl: "1157px" },
    height: { xs: "auto", md: "auto" },
    mt: { xs: "28px", md: "30px", lg: "33px", xl: "37px" },
  },
  span: {
    fontWeight: "bold",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
    mt: { xs: "77px", md: "100px", lg: "120px", xl: "167px" },
  },
  text: {
    color: theme.palette.white.main,
    fontSize: { xs: "23px", md: "25px", lg: "27px", xl: "32px" },
    lineHeight: { xs: "35px", md: "40px", lg: "45px", xl: "50px" },
    fontFamily: theme.typography.montserrat.regular,
    textAlign: { xs: "center" },
    maxWidth: { xs: "294px", md: "700px", lg: "900px", xl: "1080px" },
    height: { xs: "175x", md: "auto" },
    mt: { xs: "38px", md: "45px", lg: "55px", xl: "61px" },
  },
  slider: {
    display: "flex",
    width: "295px",
    justifyContent: "center",
    alignItems: "center",
  },
  box: { display: "flex", justifyContent: "center", width: "100%" },
  fundingCardsContainer: {
    width: "90%",
    display: "flex",
    flexDirection: { xs: "column", md: "row", lg: "row", xl: "row" },
    flexWrap: { xs: "nowrap", md: "wrap", lg: "wrap", xl: "nowrap" },
    justifyContent: "center",
    alignItems: "center",
    mt: { xs: "-332px", md: "-316px", lg: "-323px", xl: "-438px" },
    gap: { xs: "48px 0px", md: "32px", lg: "48px", xl: "0px 48px" },
  },
});

const Funding = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");

  const { pathname } = useLocation();
  const componentName = "Funding";
  const translation = useTranslation(pathname, componentName);
  const { title, subtitle, options, note, cards } = translation;

  return (
    <Box sx={classes.container} >
      <Box sx={classes.firstChild} id="funding">
        <Box sx={classes.titleContainer} >
          {isMobile ? null : <div style={classes.line}></div>}
          <Typography sx={classes.title}>{title}</Typography>
        </Box>
        <Typography sx={classes.subtitle}>
          {subtitle[0]}
          <span style={classes.span}>{subtitle[1]}</span>
        </Typography>

        <Box sx={classes.box}>
          <Typography sx={classes.text}>
            {options[0]}
            <span style={classes.span}>{options[1]}</span>
            {options[2]}
            <br />
            <br />
            <span style={classes.span}>{note}</span>
          </Typography>
        </Box>
      </Box>
      <Box sx={classes.fundingCardsContainer}>
        {cards.map((card) => (
          <Fragment key={card.title}>
            <FundingCard {...card} />
          </Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default Funding;
